import React from 'react'
import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import lang from '@/lang'
import { user } from 'ampersand-app'
import ButtonIconSquare from '@/modules/base/components/buttons/icon-square/button-icon-square'
import { userLoggedOut } from '@/redux/ducks/global'
import { useDispatch } from 'react-redux'

function PausedSubscriptionModal(props) {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { buttonCallback } = props

  const onButtonClick = () => {
    dispatch(userLoggedOut())
    user.logout(true)
    buttonCallback && buttonCallback()
  }

  const { paused: pausedLang } = lang.settings

  return (
    <div className={classes.container}>
      <div className={classes.title}>{pausedLang.title}</div>
      <div className={classes.content}>
        {pausedLang.paragraphs.map((paragraph, index) => <p className={classes.paragraph} key={index} dangerouslySetInnerHTML={{ __html: paragraph }} />)}
      </div>
      <footer className={classes.controls}>
        <ButtonIconSquare variant='outline' onClick={onButtonClick} label={pausedLang.buttonLabel} />
      </footer>
    </div>
  )
}

PausedSubscriptionModal.propTypes = {
  buttonCallback: PropTypes.func,
}

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    color: theme.text,
    textAlign: 'left',
    padding: '10px 30px',
  },
  controls: {
    alignSelf: 'flex-end',
    justifyContent: 'flex-end',
    display: 'flex',
  },
  title: {
    fontSize: theme.userSettings.h1.fontSize,
    textAlign: 'left',
  },
  paragraph: {
    marginBottom: '2em',
  },
}))

export default PausedSubscriptionModal
